// extracted by mini-css-extract-plugin
export default {"svg":"BannedIcon_svg__ubYzc","active":"BannedIcon_active__Hd9Pc"};